import { useRef, useEffect, useState } from 'react';
import styles from './PlanetCanvas.module.css';

export default function PlanetCanvas({ primary, all }) {
  const containerRef = useRef(null);
  const [angle, setAngle] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // 检测是否为移动端
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 卫星轨道动画
  useEffect(() => {
    const interval = setInterval(() => {
      setAngle((prev) => (prev + 0.4) % 360);
    }, 40);
    return () => clearInterval(interval);
  }, []);

  // 计算卫星位置（椭圆轨道）
  const orbitRadiusX = 320;
  const orbitRadiusY = 100;
  const satX = Math.cos((angle * Math.PI) / 180) * orbitRadiusX;
  const satY = Math.sin((angle * Math.PI) / 180) * orbitRadiusY;

  return (
    <div className={styles.wrapper} ref={containerRef}>
      {/* 背景星点 */}
      <div className={styles.starsLayer}>
        {all.filter((a) => a.score === 0).map((arch, i) => (
          <div
            key={arch.key}
            className={styles.bgStar}
            style={{
              left: `${(Math.sin(i * 1.3) * 0.4 + 0.5) * 100}%`,
              top: `${(Math.cos(i * 1.7) * 0.4 + 0.5) * 100}%`,
              animationDelay: `${i * 0.3}s`,
            }}
          />
        ))}
      </div>

      {/* 轨道线 - 仅桌面端显示 */}
      {!isMobile && <div className={styles.orbitPath} />}

      {/* 主星球图片 */}
      <div className={styles.mainPlanet}>
        <img src={primary.planetImg} alt={primary.planet} className={styles.planetImg} />
      </div>

      {/* 白色小卫星 - 仅桌面端显示 */}
      {!isMobile && (
        <div
          className={styles.satellite}
          style={{ transform: `translate(${satX}px, ${satY}px)` }}
        />
      )}
    </div>
  );
}
